import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '@g99-product-web-ui/prime-ng';
import { SharedSkeletonLibModule } from '@g99-product-web-ui/shared-skeleton-lib';
import { SharedUiModule } from '@g99-product-web-ui/shared-ui';
import { G99UiLibraryModule } from 'g99-ui-library';

import { GenericBannerComponent } from './components/generic-bannner/generic-banner.component';
import { MaintainenceBannerComponent } from './components/maintainence-banner/maintainence-banner.component';
import { MessageTemplatePreviewComponent } from './components/message-template-preview/message-template-preview.component';
import { SharedAssessmentDescriptionComponent } from './components/shared-assessment-description/shared-assessment-description.component';
import { SharedAssessmentToggleComponent } from './components/shared-assessment-toggle/shared-assessment-toggle.component';
import { SharedDesktopPreviewComponent } from './components/shared-desktop-preview/shared-desktop-preview.component';
import { SharedEmailTemplatePreviewComponent } from './components/shared-email-template-preview/shared-email-template-preview.component';
import { SharedMobilePreviewComponent } from './components/shared-mobile-preview/shared-mobile-preview.component';
import { SharedTemplatePreviewComponent } from './components/shared-template-preview/shared-template-preview.component';
import { SharedTemplateVariableButtonComponent } from './components/shared-template-variable-button/shared-template-variable-button.component';
import { UtmInputComponent } from './components/utm-input/utm-input.component';
@NgModule({
  imports: [
    CommonModule,
    SharedUiModule,
    SharedSkeletonLibModule,
    FormsModule,
    G99UiLibraryModule,
    PrimeNgModule,
    ReactiveFormsModule,
  ],
  declarations: [
    MessageTemplatePreviewComponent,
    SharedTemplatePreviewComponent,
    SharedMobilePreviewComponent,
    SharedDesktopPreviewComponent,
    SharedEmailTemplatePreviewComponent,
    SharedTemplateVariableButtonComponent,
    MaintainenceBannerComponent,
    GenericBannerComponent,
    SharedAssessmentToggleComponent,
    SharedAssessmentDescriptionComponent,
    UtmInputComponent,
  ],
  exports: [
    SharedTemplatePreviewComponent,
    MessageTemplatePreviewComponent,
    SharedEmailTemplatePreviewComponent,
    SharedTemplateVariableButtonComponent,
    MaintainenceBannerComponent,
    GenericBannerComponent,
    SharedAssessmentToggleComponent,
    SharedAssessmentDescriptionComponent,
    UtmInputComponent,
  ],
})
export class SharedFeatureComponentLibModule {}
